import { render, staticRenderFns } from "./LabotestImportConfirm.vue?vue&type=template&id=7d2a4ab8&scoped=true&"
import script from "./LabotestImportConfirm.vue?vue&type=script&lang=ts&"
export * from "./LabotestImportConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./LabotestImportConfirm.vue?vue&type=style&index=0&id=7d2a4ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2a4ab8",
  null
  
)

export default component.exports